import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class PropertiesSlider {
    constructor($el) {
        this.$el = $el;
        this.$dots = null;
        this.$nextBtn = null;

        this.options = {
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            cellSelector: '.offer',
			cellAlign: 'left'
        };

        if(this.$el.length) {
            this._init();
            // this._bindEvents();
        }
    }

	_equalizeSlidesHeight() {
		const slides = this.$el.find('.offer');

		// Reset pour recalculer correctement
		slides.css('height', '');

		let maxHeight = 0;

		slides.each((index, slide) => {
			const height = $(slide).outerHeight();
			maxHeight = Math.max(maxHeight, height);
		});

		slides.css('height', `${maxHeight}px`);
	}

    _init() {
        this.$slides = this.$el.find('.offer');
        this.slidesCount = this.$slides.length;

		this._equalizeSlidesHeight();
		this._checkSlider();

		let resizeTimer;

		$(window).on("resize", () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this._equalizeSlidesHeight();
				this._checkSlider();
			}, 200);
		});
    }

    _checkSlider() {
		const width = document.body.clientWidth;

		let shouldInit = false;

		if (width < 828 && this.slidesCount > 1) {
			shouldInit = true;
		} else if (width >= 828 && width < 1410 && this.slidesCount > 2) {
			shouldInit = true;
		} else if (width >= 1410 && this.slidesCount > 3) {
			shouldInit = true;
		}

		if (shouldInit && !this.slider) {
			this._createSlider();
			console.log("Carrousel des biens en loc - slider init");
		}

		if (!shouldInit && this.slider) {
			this.slider.destroy();
			this.slider = null;
			console.log("Carousel des biens en loc - slider destroyed");
		}
	}

	_createSlider() {
        new Flickity(this.$el[0], this.options);
    }

}

export default PropertiesSlider;
